<template>
  <div>
    <div class="d-flex mb-3 align-items-center justify-content-between">
      <base-heading
        :level="2"
        class="pl-2"
      >
        {{ title }}
      </base-heading>
      <div class="d-flex">
        <div v-if="showSearch && mode === 'pagination'">
          <base-search v-model="search" />
        </div>
        <div
          v-if="showAddButton"
          class="d-flex align-items-stretch"
        >
          <base-button
            nowrap
            small
            class="px-2"
            inverse
            @click="$emit('click')"
          >
            <base-icon
              :icon="buttonIcon"
              class="mr-1"
            />
            {{ buttonTitle }}
          </base-button>
        </div>
      </div>
    </div>
    <div
      v-if="loading && !requestFailed"
      class="justify-content-md-center"
    >
      <strong>{{ loadingLabel }} </strong>
      <font-awesome-icon
        icon="spinner"
        spin
      />
    </div>
    <div v-else-if="requestFailed">
      <strong> {{ errorLabel }} </strong>
      <ButtonMore
        :loading="false"
        :label="tryAgainLabel"
        @click="reload()"
      />
    </div>
    <div v-else>
      <slot
        v-if="elements.length === 0"
        name="nodata"
      >
        <div>No data!</div>
        <ButtonMore
          :loading="loading"
          :label="reloadLabel"
          :caret="false"
          @click="reload()"
        />
      </slot>
      <div
        v-for="(element, index) in elements"
        v-else
        :key="index"
      >
        <slot
          name="element"
          :element="element"
        >
          <div> Element #{{ index }}</div>
        </slot>
      </div>
      <slot
        v-if="mode === 'loadMore'"
        name="loadMore"
      >
        <div v-if="elements.length !== 0 && showLoadMore">
          <b-row class="justify-content-md-center">
            <div v-if="showLoadMore">
              <ButtonMore
                :loading="loading"
                :label="loadMoreLabel"
                @click="loadMore()"
              />
            </div>
          </b-row>
        </div>
      </slot>
      <slot
        v-else-if="mode === 'pagination'"
        name="pagination"
      >
        <Pagination
          :per-page="pageSize"
          :current="truePage"
          :module="source"
          :path="paginationRoute"
        />
      </slot>
    </div>
  </div>
</template>
<script>

import Listable from './mixins/listable';

export default {
  name: 'GenericList',
  mixins: [Listable],
  props: {
    source: {
      type: String,
    },
    title: {
      type: String,
    },
    showAddButton: {
      type: Boolean,
      default: false,
    },
    buttonTitle: {
      type: String,
    },
    buttonIcon: {
      type: String,
      default: 'plus',
    },
    pageSize: {
      type: Number,
      default: 25,
    },
  },
};
</script>
